import { setAuthenticated } from "@redux/auth/auth";
import { AppDispatch } from "@store/store";
import { LOGIN_URL } from "@utils/baseURL";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

const Login: FC = () => {
  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    dispatch(setAuthenticated(false));
    const lang = navigator.languages
      ? navigator.languages[0]
      : navigator.language;
    window.location.href = LOGIN_URL + "&ui_locales=" + lang;
  }, []);

  return <></>;
};

export default Login;
